import { render, staticRenderFns } from "./TopTres.vue?vue&type=template&id=3f2c4006&"
import script from "./TopTres.vue?vue&type=script&lang=js&"
export * from "./TopTres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports